export default __webpack_public_path__ + "static/media/KP.fafef161.svg";